"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UtilsService", {
    enumerable: true,
    get: function() {
        return UtilsService;
    }
});
const _process = /*#__PURE__*/ _interop_require_default(require("process"));
const _common = require("@nestjs/common");
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _compareversions = require("compare-versions");
const _nocodbsdk = require("nocodb-sdk");
const _config = require("@nestjs/config");
const _requestfilteringagent = require("request-filtering-agent");
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _constants = require("~/constants");
const _SqlMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/db/sql-mgr/v2/SqlMgrv2"));
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _utils = require("~/utils");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _getInstance = /*#__PURE__*/ _interop_require_default(require("~/utils/getInstance"));
const _globals = require("~/utils/globals");
const _helpers = require("~/utils/nc-config/helpers");
const _packageVersion = require("~/utils/packageVersion");
const _extractLimitAndOffset = require("~/helpers/extractLimitAndOffset");
const _ncconfig = require("~/utils/nc-config");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const versionCache = {
    releaseVersion: null,
    lastFetched: null
};
const defaultConnectionConfig = {
    // https://github.com/knex/knex/issues/97
    // timezone: process.env.NC_TIMEZONE || 'UTC',
    dateStrings: true
};
let UtilsService = class UtilsService {
    async versionInfo() {
        if (!versionCache.lastFetched || versionCache.lastFetched && versionCache.lastFetched < Date.now() - 1000 * 60 * 60) {
            const nonBetaTags = await _axios.default.get('https://api.github.com/repos/nocodb/nocodb/tags', {
                timeout: 5000
            }).then((response)=>{
                return response.data.map((x)=>x.name).filter((v)=>(0, _compareversions.validate)(v) && // also filter only XXX.XXX.XXX version. ex: 0.263.8
                    v.match(/^\d+\.\d+\.\d+$/)).sort((x, y)=>(0, _compareversions.compareVersions)(y, x));
            }).catch(()=>null);
            if (nonBetaTags && nonBetaTags.length > 0) {
                versionCache.releaseVersion = nonBetaTags[0];
            }
            versionCache.lastFetched = Date.now();
        }
        const response = {
            currentVersion: _packageVersion.packageVersion,
            releaseVersion: versionCache.releaseVersion
        };
        return response;
    }
    async appHealth() {
        return {
            message: 'OK',
            timestamp: Date.now(),
            uptime: _process.default.uptime()
        };
    }
    async _axiosRequestMake(param) {
        const { apiMeta } = param.body;
        if (apiMeta == null ? void 0 : apiMeta.body) {
            try {
                apiMeta.body = JSON.parse(apiMeta.body);
            } catch (e) {
                console.log(e);
            }
        }
        if (apiMeta == null ? void 0 : apiMeta.auth) {
            try {
                apiMeta.auth = JSON.parse(apiMeta.auth);
            } catch (e) {
                console.log(e);
            }
        }
        apiMeta.response = {};
        const _req = {
            params: apiMeta.parameters ? apiMeta.parameters.reduce((paramsObj, param)=>{
                if (param.name && param.enabled) {
                    paramsObj[param.name] = param.value;
                }
                return paramsObj;
            }, {}) : {},
            url: apiMeta.url,
            method: apiMeta.method || 'GET',
            data: apiMeta.body || {},
            headers: apiMeta.headers ? apiMeta.headers.reduce((headersObj, header)=>{
                if (header.name && header.enabled) {
                    headersObj[header.name] = header.value;
                }
                return headersObj;
            }, {}) : {},
            responseType: apiMeta.responseType || 'json',
            withCredentials: true,
            httpAgent: (0, _requestfilteringagent.useAgent)(apiMeta.url),
            httpsAgent: (0, _requestfilteringagent.useAgent)(apiMeta.url)
        };
        const data = await (0, _axios.default)(_req);
        return data == null ? void 0 : data.data;
    }
    async axiosRequestMake(param) {
        const { apiMeta: { url } } = param.body;
        const isExcelImport = /.*\.(xls|xlsx|xlsm|ods|ots)/;
        const isCSVImport = /.*\.(csv)/;
        const ipBlockList = /(10)(\.([2]([0-5][0-5]|[01234][6-9])|[1][0-9][0-9]|[1-9][0-9]|[0-9])){3}|(172)\.(1[6-9]|2[0-9]|3[0-1])(\.(2[0-4][0-9]|25[0-5]|[1][0-9][0-9]|[1-9][0-9]|[0-9])){2}|(192)\.(168)(\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])){2}|(0.0.0.0)|localhost?/g;
        if (ipBlockList.test(url) || !isCSVImport.test(url) && !isExcelImport.test(url)) {
            return {};
        }
        if (isCSVImport || isExcelImport) {
            param.body.apiMeta.responseType = 'arraybuffer';
        }
        return await this._axiosRequestMake({
            body: param.body
        });
    }
    async urlToDbConfig(param) {
        const { url } = param.body;
        try {
            const connectionConfig = (0, _helpers.jdbcToXcConfig)(url);
            return connectionConfig;
        } catch (error) {
            return _catchError.NcError.internalServerError('Please check server log for more details');
        }
    }
    async aggregatedMetaInfo() {
        // TODO: fix or deprecate for EE
        const [bases, userCount] = await Promise.all([
            _models.Base.list(),
            _Noco.default.ncMeta.metaCount(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.USERS)
        ]);
        const result = {
            baseCount: bases.length,
            bases: [],
            userCount,
            sharedBaseCount: 0
        };
        result.bases.push(...this.extractResultOrNull(await Promise.allSettled(bases.map(async (base)=>{
            if (base.uuid) result.sharedBaseCount++;
            const [tableCount, dbViewCount, viewCount, webhookCount, filterCount, sortCount, rowCount, userCount] = this.extractResultOrNull(await Promise.allSettled([
                // db tables  count
                _Noco.default.ncMeta.metaCount(base.fk_workspace_id, base.id, _globals.MetaTable.MODELS, {
                    condition: {
                        type: 'table'
                    }
                }),
                // db views count
                _Noco.default.ncMeta.metaCount(base.fk_workspace_id, base.id, _globals.MetaTable.MODELS, {
                    condition: {
                        type: 'view'
                    }
                }),
                // views count
                (async ()=>{
                    const views = await _Noco.default.ncMeta.metaList2(base.fk_workspace_id, base.id, _globals.MetaTable.VIEWS);
                    // grid, form, gallery, kanban and shared count
                    return views.reduce((out, view)=>{
                        out.total++;
                        switch(view.type){
                            case _nocodbsdk.ViewTypes.GRID:
                                out.gridCount++;
                                if (view.uuid) out.sharedGridCount++;
                                break;
                            case _nocodbsdk.ViewTypes.FORM:
                                out.formCount++;
                                if (view.uuid) out.sharedFormCount++;
                                break;
                            case _nocodbsdk.ViewTypes.GALLERY:
                                out.galleryCount++;
                                if (view.uuid) out.sharedGalleryCount++;
                                break;
                            case _nocodbsdk.ViewTypes.KANBAN:
                                out.kanbanCount++;
                                if (view.uuid) out.sharedKanbanCount++;
                        }
                        if (view.uuid) {
                            if (view.password) out.sharedLockedCount++;
                            out.sharedTotal++;
                        }
                        return out;
                    }, {
                        formCount: 0,
                        gridCount: 0,
                        galleryCount: 0,
                        kanbanCount: 0,
                        total: 0,
                        sharedFormCount: 0,
                        sharedGridCount: 0,
                        sharedGalleryCount: 0,
                        sharedKanbanCount: 0,
                        sharedTotal: 0,
                        sharedLockedCount: 0
                    });
                })(),
                // webhooks count
                _Noco.default.ncMeta.metaCount(base.fk_workspace_id, base.id, _globals.MetaTable.HOOKS),
                // filters count
                _Noco.default.ncMeta.metaCount(base.fk_workspace_id, base.id, _globals.MetaTable.FILTER_EXP),
                // sorts count
                _Noco.default.ncMeta.metaCount(base.fk_workspace_id, base.id, _globals.MetaTable.SORT),
                // row count per base
                base.getSources().then(async (sources)=>{
                    return this.extractResultOrNull(await Promise.allSettled(sources.map(async (source)=>{
                        var _totalRecords, _totalRecords1, _this;
                        return (_totalRecords1 = (_this = await _NcConnectionMgrv2.default.getSqlClient(source)).totalRecords) == null ? void 0 : (_totalRecords = _totalRecords1.call(_this)) == null ? void 0 : _totalRecords.then((result)=>result == null ? void 0 : result.data);
                    })));
                }),
                // base users count
                _Noco.default.ncMeta.metaCount(base.fk_workspace_id, base.id, _globals.MetaTable.PROJECT_USERS, {
                    condition: {
                        base_id: base.id
                    },
                    aggField: '*'
                })
            ]));
            return {
                tableCount: {
                    table: tableCount,
                    view: dbViewCount
                },
                external: !base.is_meta,
                viewCount,
                webhookCount,
                filterCount,
                sortCount,
                rowCount,
                userCount
            };
        }))));
        return result;
    }
    async testConnection(param) {
        return await _SqlMgrv2.default.testConnection(param.body);
    }
    async appInfo(param) {
        var _process_env_NC_OIDC_PROVIDER_NAME, _process_env_NC_SSO_SAML_PROVIDER_NAME;
        var _process_env_NC_SSO, _process_env_NC_SSO1, _Noco_getConfig_meta_db, _Noco_getConfig_meta, _Noco_getConfig;
        const baseHasAdmin = !await _models.User.isFirst();
        const instance = await (0, _getInstance.default)();
        const settings = await _Noco.default.getAppSettings();
        const oidcAuthEnabled = [
            'openid',
            'oidc'
        ].includes((_process_env_NC_SSO = _process.default.env.NC_SSO) == null ? void 0 : _process_env_NC_SSO.toLowerCase());
        const oidcProviderName = oidcAuthEnabled ? (_process_env_NC_OIDC_PROVIDER_NAME = _process.default.env.NC_OIDC_PROVIDER_NAME) != null ? _process_env_NC_OIDC_PROVIDER_NAME : 'OpenID Connect' : null;
        let giftUrl;
        if (instance.impacted >= 5) {
            giftUrl = `https://w21dqb1x.nocodb.com/#/nc/form/4d2e0e4b-df97-4c5e-ad8e-f8b8cca90330?Users=${instance.impacted}&Bases=${instance.projectsExt + instance.projectsMeta}`;
        }
        const samlAuthEnabled = ((_process_env_NC_SSO1 = _process.default.env.NC_SSO) == null ? void 0 : _process_env_NC_SSO1.toLowerCase()) === 'saml';
        const samlProviderName = samlAuthEnabled ? (_process_env_NC_SSO_SAML_PROVIDER_NAME = _process.default.env.NC_SSO_SAML_PROVIDER_NAME) != null ? _process_env_NC_SSO_SAML_PROVIDER_NAME : 'SAML' : null;
        const result = _extends({
            authType: 'jwt',
            baseHasAdmin,
            firstUser: !baseHasAdmin,
            type: 'rest',
            env: _process.default.env.NODE_ENV,
            googleAuthEnabled: !!(_process.default.env.NC_GOOGLE_CLIENT_ID && _process.default.env.NC_GOOGLE_CLIENT_SECRET),
            githubAuthEnabled: !!(_process.default.env.NC_GITHUB_CLIENT_ID && _process.default.env.NC_GITHUB_CLIENT_SECRET),
            oidcAuthEnabled,
            oidcProviderName,
            oneClick: !!_process.default.env.NC_ONE_CLICK,
            connectToExternalDB: !_process.default.env.NC_CONNECT_TO_EXTERNAL_DB_DISABLED,
            version: _packageVersion.packageVersion,
            defaultLimit: Math.max(Math.min(_extractLimitAndOffset.defaultLimitConfig.limitDefault, _extractLimitAndOffset.defaultLimitConfig.limitMax), _extractLimitAndOffset.defaultLimitConfig.limitMin),
            defaultGroupByLimit: _extractLimitAndOffset.defaultGroupByLimitConfig,
            timezone: defaultConnectionConfig.timezone,
            ncMin: !!_process.default.env.NC_MIN,
            teleEnabled: _process.default.env.NC_DISABLE_TELE !== 'true',
            errorReportingEnabled: _process.default.env.NC_DISABLE_ERR_REPORTS !== 'true',
            sentryDSN: _process.default.env.NC_DISABLE_ERR_REPORTS !== 'true' ? _process.default.env.NC_SENTRY_DSN : null,
            auditEnabled: _process.default.env.NC_DISABLE_AUDIT !== 'true',
            ncSiteUrl: param.req.ncSiteUrl,
            ee: _Noco.default.isEE(),
            ncAttachmentFieldSize: _constants.NC_ATTACHMENT_FIELD_SIZE,
            ncMaxAttachmentsAllowed: _constants.NC_MAX_ATTACHMENTS_ALLOWED,
            isCloud: _utils.isCloud,
            automationLogLevel: _process.default.env.NC_AUTOMATION_LOG_LEVEL || 'OFF',
            baseHostName: _process.default.env.NC_BASE_HOST_NAME,
            disableEmailAuth: this.configService.get('auth.disableEmailAuth', {
                infer: true
            }),
            feedEnabled: _process.default.env.NC_DISABLE_PRODUCT_FEED !== 'true',
            mainSubDomain: this.configService.get('mainSubDomain', {
                infer: true
            }),
            dashboardPath: this.configService.get('dashboardPath', {
                infer: true
            }),
            inviteOnlySignup: settings.invite_only_signup,
            restrictWorkspaceCreation: settings.restrict_workspace_creation,
            samlProviderName,
            samlAuthEnabled,
            giftUrl,
            prodReady: ((_Noco_getConfig = _Noco.default.getConfig()) == null ? void 0 : (_Noco_getConfig_meta = _Noco_getConfig.meta) == null ? void 0 : (_Noco_getConfig_meta_db = _Noco_getConfig_meta.db) == null ? void 0 : _Noco_getConfig_meta_db.client) !== _ncconfig.DriverClient.SQLITE,
            allowLocalUrl: _process.default.env.NC_ALLOW_LOCAL_HOOKS === 'true',
            isOnPrem: _utils.isOnPrem,
            disableSupportChat: _ncconfig.NC_DISABLE_SUPPORT_CHAT,
            disableGroupByAggregation: _ncconfig.NC_DISABLE_GROUP_BY_AGG,
            /**
       * Allow disabling onboarding flow based on env variable or development mode
       *
       * TODO: @rameshmane7218 remove test env once we enable onboarding flow in playwright
       */ disableOnboardingFlow: _process.default.env.NC_DISABLE_ONBOARDING_FLOW === 'true' || _process.default.env.NODE_ENV === 'development' || _process.default.env.NODE_ENV === 'test'
        }, _utils.isEE === false ? {
            ncDefaultWorkspaceId: _Noco.default.ncDefaultWorkspaceId || null
        } : {});
        return result;
    }
    async reportErrors(param) {
        var _ref;
        var _param_body;
        for (const error of (_ref = (_param_body = param.body) == null ? void 0 : _param_body.errors) != null ? _ref : []){
            var _error_stack;
            _utils.T.emit('evt', {
                evt_type: 'gui:error',
                properties: _extends({
                    message: error.message,
                    stack: (_error_stack = error.stack) == null ? void 0 : _error_stack.split('\n').slice(0, 2).join('\n')
                }, param.body.extra || {})
            });
        }
    }
    async feed(req) {
        const { type = 'all', page = '1', per_page = '10' } = req.query;
        const perPage = Math.min(Math.max(parseInt(per_page, 10) || 10, 1), 100);
        const pageNum = Math.max(parseInt(page, 10) || 1, 1);
        const cacheKey = `${_globals.CacheScope.PRODUCT_FEED}:${type}:${pageNum}:${perPage}`;
        const cachedData = await _NocoCache.default.get('root', cacheKey, 'json');
        if (cachedData) {
            try {
                return JSON.parse(cachedData);
            } catch (e) {
                this.logger.error(e == null ? void 0 : e.message, e);
                await _NocoCache.default.del('root', cacheKey);
            }
        }
        let payload = null;
        if (!this.lastSyncTime || (0, _dayjs.default)().isAfter(this.lastSyncTime.add(3, 'hours'))) {
            payload = await _utils.T.payload();
            this.lastSyncTime = (0, _dayjs.default)();
        }
        let response;
        try {
            response = await _axios.default.post('https://product-feed.nocodb.com/api/v1/social/feed', payload, {
                params: {
                    per_page: perPage,
                    page: pageNum,
                    type
                }
            });
        } catch (e) {
            this.logger.error(e == null ? void 0 : e.message, e);
            return [];
        }
        // The feed includes the attachments, which has the presigned URL
        // So the cache should match the presigned URL cache
        await _NocoCache.default.setExpiring('root', cacheKey, JSON.stringify(response.data, _nocodbsdk.getCircularReplacer), Number.isNaN(parseInt(_process.default.env.NC_ATTACHMENT_EXPIRE_SECONDS)) ? 2 * 60 * 60 : parseInt(_process.default.env.NC_ATTACHMENT_EXPIRE_SECONDS));
        return response.data;
    }
    async cloudFeatures(_req) {
        const cacheKey = `${_globals.CacheScope.CLOUD_FEATURES}`;
        const cachedData = await _NocoCache.default.get('root', cacheKey, 'json');
        if (cachedData) {
            try {
                return JSON.parse(cachedData);
            } catch (e) {
                this.logger.error(e == null ? void 0 : e.message, e);
                await _NocoCache.default.del('root', cacheKey);
            }
        }
        let payload = null;
        if (!this.lastSyncTime || (0, _dayjs.default)().isAfter(this.lastSyncTime.add(3, 'hours'))) {
            payload = await _utils.T.payload();
            this.lastSyncTime = (0, _dayjs.default)();
        }
        let response;
        try {
            response = await _axios.default.post('https://product-feed.nocodb.com/api/v1/cloud/features', payload);
        } catch (e) {
            this.logger.error(e == null ? void 0 : e.message, e);
            return [];
        }
        await _NocoCache.default.setExpiring('root', cacheKey, JSON.stringify(response.data, _nocodbsdk.getCircularReplacer), 3 * 60 * 60);
        return response.data;
    }
    constructor(configService){
        this.configService = configService;
        this.logger = new _common.Logger(UtilsService.name);
        this.lastSyncTime = null;
        this.extractResultOrNull = (results)=>{
            return results.map((result)=>{
                if (result.status === 'fulfilled') {
                    return result.value;
                }
                return null;
            });
        };
    }
};
UtilsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.ConfigService === "undefined" ? Object : _config.ConfigService
    ])
], UtilsService);
